export default __webpack_public_path__ + "static/media/code.9bf5d809.png";